import React, { useState } from "react";
import PropTypes from "prop-types";
import "./IndividualProject.css";

const Project = ({
  thumbnailSrc,
  projectTitle,
  projectUrl,
  projectDescription,
  projectStack,
  animationDelay = 0,
}) => {
  const [showAllTech, setShowAllTech] = useState(false);
  const handleClick = () => {
    if (projectUrl != null) window.open(projectUrl, "_blank");
  };

  const delayStyle = {
    animationDelay: `${animationDelay * 0.1}s`,
  };
  const primaryStack = projectStack.slice(0, 3);
  const overflowStack = projectStack.slice(3);
  const stackCount = projectStack.length;
  const destinationLabel = projectUrl ? "Open project" : "Case study available";

  return (
    <article
      role={projectUrl ? "button" : undefined}
      aria-label={projectUrl ? `Open ${projectTitle}` : undefined}
      tabIndex={projectUrl ? 0 : undefined}
      onClick={handleClick}
      onKeyDown={(e) => {
        if (projectUrl && (e.key === 'Enter' || e.key === ' ')) {
          e.preventDefault();
          handleClick();
        }
      }}
      className={`project-card ${projectUrl ? "project-card-interactive" : ""}`}
      style={delayStyle}
    >
      <div className="project-media">
        <img
          src={thumbnailSrc}
          alt={`Thumbnail of ${projectTitle}`}
          className="project-thumbnail"
        />
      </div>
      <div className="project-body">
        <div className="project-meta">
          <span>{String(animationDelay + 1).padStart(2, "0")}</span>
          <span>{stackCount} technologies</span>
          <span>{destinationLabel}</span>
        </div>
        <h3 className="project-title">{projectTitle}</h3>
        <p className="project-description">{projectDescription}</p>
        <div className="project-stack-row">
          {primaryStack.map((stack) => (
            <span key={stack} className="project-chip">
              {stack}
            </span>
          ))}
          {showAllTech
            ? overflowStack.map((stack) => (
              <span key={stack} className="project-chip project-chip-secondary">
                {stack}
              </span>
            ))
            : null}
          {!showAllTech && overflowStack.length > 0 ? (
            <button
              type="button"
              className="project-chip-toggle"
              onClick={(event) => {
                event.stopPropagation();
                setShowAllTech(true);
              }}
            >
              +{overflowStack.length} more
            </button>
          ) : null}
        </div>
      </div>
    </article>
  );
};

Project.propTypes = {
  thumbnailSrc: PropTypes.string.isRequired,
  projectTitle: PropTypes.string.isRequired,
  projectUrl: PropTypes.string,
  projectDescription: PropTypes.string.isRequired,
  projectStack: PropTypes.array.isRequired,
};

export default Project;
